// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "item-2q8Fv";
var _3 = "item_selected-39Atd";
var _4 = "item__icon-3R5sc";
export { _1 as "__esModule", _2 as "item", _3 as "item_selected", _4 as "item__icon" }
export default { "__esModule": _1, "item": _2, "item_selected": _3, "item__icon": _4 }
